import { useEffect, useState } from "react";

const KEY = "swana-coach.small-screen-note.dismissed";
const PHONE = "(max-width: 820px)";

const read = (): boolean => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } };
const remember = () => { try { localStorage.setItem(KEY, "1"); } catch { /* private window: the note comes back next visit, which is fine */ } };

/** On a phone, a dismissible line saying the review is easier on a bigger screen, with the link to hand. */
export function SmallScreenNote() {
    const [phone, setPhone] = useState(() => typeof window !== "undefined" && window.matchMedia(PHONE).matches);
    const [dismissed, setDismissed] = useState(read);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        const mq = window.matchMedia(PHONE);
        const onChange = () => setPhone(mq.matches);
        mq.addEventListener("change", onChange);
        return () => mq.removeEventListener("change", onChange);
    }, []);

    if (!phone || dismissed) return null;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            setCopied(true);
        } catch {
            setCopied(false);
            window.prompt("Copy this link to open the review on a bigger screen", window.location.href);
        }
    };
    const dismiss = () => { remember(); setDismissed(true); };

    return (
        <div className="banner small-screen" role="status">
            <span>Reviewing is easier on an iPad or a computer: a bigger frame to draw on and room for your notes.</span>
            <div className="banner-actions">
                <button className="btn small" onClick={() => void copy()}>{copied ? "Link copied" : "Copy link"}</button>
                <button className="btn ghost small" onClick={dismiss} aria-label="Dismiss">Carry on here</button>
            </div>
        </div>
    );
}
